import CryptoJS from 'crypto-js'

const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString()
}

// Decrypt function
export const decryptData = (ciphertext) => {
  if (!ciphertext) return null

  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY)
  const decryptedText = bytes.toString(CryptoJS.enc.Utf8)

  return decryptedText || null
}

export const setSessionStorageItem = (key, value) => {
  const encryptedValue = encryptData(value)
  sessionStorage.setItem(key, encryptedValue)
}

export const getSessionStorageItem = (key) => {
  const encryptedValue = sessionStorage.getItem(key)
  if (encryptedValue) {
    return decryptData(encryptedValue)
  }
  return null
}
